import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import WebsiteHeader from "../WebsiteHeader"

const Pictorial = ({
  buttonClick,
  actionText,
  coverImageUrl,
  rsvpButtonColor,
  title,
}: {
  buttonClick: (() => void) | null
  actionText: string
  coverImageUrl: string
  rsvpButtonColor: string
  title: string
}) => {
  const hasImage = !!coverImageUrl

  return (
    <Box
      bgImage={hasImage ? `url("${coverImageUrl}")` : undefined}
      bgColor={hasImage ? undefined : "gray.200"}
      bgPosition="center"
      bgSize="cover"
      h="50vh"
      pos="relative"
    >
      {!hasImage && (
        <Flex pos="absolute" inset={0} align="center" justify="center" pb={20}>
          <Icon icon="email-block-image" size={36} color="gray.300" />
        </Flex>
      )}
      <Box
        pos="absolute"
        bottom={0}
        left={0}
        width="100%"
        minHeight="80px"
        padding="22px"
        color="white"
      >
        <Box
          bgColor="black"
          opacity="0.5"
          h="100%"
          w="100%"
          bottom={0}
          left={0}
          pos="absolute"
        />
        <Flex mx="auto" px={10} maxW="1140px">
          <WebsiteHeader
            title={title}
            buttonClick={buttonClick}
            actionText={actionText}
            rsvpButtonColor={rsvpButtonColor}
          />
        </Flex>
      </Box>
    </Box>
  )
}

export default Pictorial
